export default function ParallaxSection() {
  return (
    <section
      style={{
        position: "relative",
        height: "90vh",
        overflow: "hidden",
      }}
    >
      {/* Background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: "url('/assets/room/room.png')",          
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          transform: "scale(1.08)",
        }}
      />

      {/* Dark Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(rgba(0,0,0,.30), rgba(0,0,0,.45))",
        }}
      />

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "0 32px",
        }}
      >
        <div>
          <p
            style={{
              color: "#E9D5A6",
              letterSpacing: ".18em",
              fontFamily: "'JetBrains Mono', monospace",
              marginBottom: 24,
            }}
          >
            STAY • EXPERIENCE • RELAX
          </p>

          <h2
            style={{
              color: "#FFF",
              fontFamily: "'Fraunces', serif",
              fontSize: "clamp(48px, 7vw, 82px)",
              lineHeight: 1.05,
              fontWeight: 400,
              marginBottom: 28,
            }}
          >
            Stay Longer.
            <br />
            Live Better.
          </h2>

          <p
            style={{
              color: "rgba(255,255,255,.88)",
              maxWidth: 700,
              margin: "0 auto",
              lineHeight: 1.8,
              fontSize: 19,
            }}
          >
            Discover thoughtfully designed serviced apartments
            where modern comfort meets the warmth of home in the
            heart of Whitefield.
          </p>
        </div>
      </div>
    </section>
  );
}